module.exports = __webpack_public_path__ + "img/PYG.a3e6d32f.svg";